// src/pages/Admin/UserManagement.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function UserManagement() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [addFunds, setAddFunds] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Add Funds request ট্র্যাক করবে

  // ✅ Fetch Users
  const fetchUsers = async () => {
    try {
      const res = await axios.get("https://api.earnmoney0.top/admin/users");
      if (res.data.success) {
        setUsers(res.data.users);
      } else {
        alert("❌ Failed to fetch users");
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
    const interval = setInterval(fetchUsers, 15000);
    return () => clearInterval(interval);
  }, []);

  // ✅ Filter Users
  const filteredUsers = users.filter(
  (u) =>
    u.name?.toLowerCase().includes(search.toLowerCase()) ||
    u.phone?.toLowerCase().includes(search.toLowerCase())
);

  // ✅ Toggle Status
  const toggleStatus = async (userId, newStatus) => {
    try {
      const res = await axios.put(
        `https://api.earnmoney0.top/api/admin/user-status/${userId}`,
        { status: newStatus }
      );
      if (res.data.success && res.data.user) {
        setUsers((prev) =>
  prev.map((u) => (u._id === userId ? { ...u, accountStatus: res.data.user.accountStatus } : u))
);
        await fetchUsers();
        // Notification
        const msg = document.createElement("div");
        msg.textContent =
          newStatus === "active"
            ? "✅ User Activated Successfully!"
            : "🚫 User Suspended Successfully!";
        msg.style.cssText =
          "position:fixed;top:20px;right:20px;padding:10px 18px;font-weight:600;border-radius:8px;box-shadow:0 0 15px rgba(0,0,0,0.5);z-index:9999;" +
          (newStatus === "active" ? "background:#4ade80;color:#0b0f1a;" : "background:#f87171;color:#0b0f1a;");
        document.body.appendChild(msg);
        setTimeout(() => msg.remove(), 2000);
      } else alert("❌ Failed to update user status.");
    } catch (err) {
      console.error("Status update failed:", err);
      alert("⚠️ Something went wrong!");
    }
  };

  // ✅ Add Funds
  const handleAddFunds = async () => {
  if (isSubmitting) return; // ✅ prevent multiple clicks
  if (!selectedUser || !addFunds) return;

  setIsSubmitting(true); // start submission

  try {
    const res = await axios.post(
      `https://api.earnmoney0.top/admin/addfund/${selectedUser._id}`,
      { amount: addFunds }
    );
    if (res.data.success) {
      alert("✅ Funds added successfully!");
      setAddFunds("");
      setSelectedUser(null);
      await fetchUsers(); // refresh users
    } else {
      alert(res.data.message || "❌ Failed to add funds");
    }
  } catch (err) {
    console.error("Add fund failed:", err);
    alert("❌ Add funds request failed");
  } finally {
    setIsSubmitting(false); // end submission
  }
};

  return (
    <div className="user-management-page">
      {/* Inline CSS */}
      <style>{`
        .user-management-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }
        h1 {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 24px;
          color: #ffd700;
        }
        .search-box {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #111827;
          padding: 8px 12px;
          border-radius: 8px;
          margin-bottom: 24px;
        }
        .search-box input {
          flex: 1;
          background: transparent;
          border: none;
          color: white;
          outline: none;
          font-size: 14px;
        }
        .table-wrapper {
          overflow-x: auto;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }
        th {
          background: #111827;
          color: #f2a900;
          padding: 12px;
          text-align: left;
          border-bottom: 1px solid #444;
        }
        td {
          padding: 12px;
          border-bottom: 1px solid #444;
        }
        tbody tr:hover {
          background: #1b2138;
          transition: background 0.3s;
        }
        .balance {
          color: #ffd700;
          font-weight: 600;
        }
        .status-active {
          color: #4ade80;
          font-weight: 600;
        }
        .status-suspended {
          color: #facc15;
          font-weight: 600;
        }
        .actions button {
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          margin-right: 6px;
        }
        .btn-activate {
          background: #4ade8040;
          color: #4ade80;
        }
        .btn-activate:hover {
          background: #4ade8050;
        }
        .btn-suspend {
          background: #facc1540;
          color: #facc15;
        }
        .btn-suspend:hover {
          background: #facc1550;
        }
        .btn-addfund {
          background: #6c63ff40;
          color: #6c63ff;
        }
        .btn-addfund:hover {
          background: #6c63ff50;
        }
        /* Modal */
        .modal-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 50;
        }
        .modal-content {
          background: #111827;
          padding: 24px;
          border-radius: 16px;
          width: 320px;
        }
        .modal-content h2 {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 12px;
          text-align: center;
        }
        .modal-content input {
          width: 100%;
          padding: 8px 10px;
          border-radius: 6px;
          border: 1px solid #444;
          background: transparent;
          color: white;
          margin-bottom: 12px;
        }
        .modal-buttons {
          display: flex;
          justify-content: space-between;
        }
        .modal-buttons button {
          flex: 1;
          margin: 0 4px;
        }
        @media (min-width: 768px) {
          .search-box input {
            font-size: 16px;
          }
          th, td {
            font-size: 14px;
          }
        }
      `}</style>

      <h1>👥 User Management</h1>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search by username or phone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Username</th>
              <th>Phone</th>
              <th>Balance Info</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", color: "#888", fontStyle: "italic", padding: "20px" }}>
                  No users found
                </td>
              </tr>
            ) : (
              filteredUsers.map((user, idx) => (
                <tr key={user._id}>
                  <td>{idx + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.phone || "N/A"}</td>
                  <td className="balance">৳{Number(user.mainBalance || 0).toFixed(2)}</td>
                  <td className={user.accountStatus?.toLowerCase() === "active" ? "status-active" : "status-suspended"}>
  {user.accountStatus || "Active"}
</td>
                  <td className="actions">
                    <button
  onClick={() => toggleStatus(user._id, "active")}
  disabled={user.accountStatus?.toLowerCase() === "active"}
  className="btn-activate"
>
  Activate
</button>
<button
  onClick={() => toggleStatus(user._id, "suspended")}
  disabled={user.accountStatus?.toLowerCase() === "suspended"}
  className="btn-suspend"
>
  Suspend
</button>
                    <button
                      onClick={() => setSelectedUser(user)}
                      className="btn-addfund"
                    >
                      Add Funds
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Add Funds Modal */}
      {selectedUser && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h2>💰 Add Funds</h2>
            <p style={{ textAlign: "center", color: "#aaa", marginBottom: "12px" }}>
              To: <span style={{ color: "#ffd700" }}>{selectedUser.name}</span>
            </p>
            <input
              type="number"
              placeholder="Enter amount"
              value={addFunds}
              onChange={(e) => setAddFunds(e.target.value)}
            />
            <div className="modal-buttons">
              <button
  onClick={handleAddFunds}
  disabled={isSubmitting || !addFunds}
  style={{
    background: isSubmitting ? "#9d4edd" : "#6c63ff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "8px",
    cursor: isSubmitting ? "not-allowed" : "pointer",
  }}
>
  {isSubmitting ? "Processing..." : "Add"}
</button>
              <button onClick={() => setSelectedUser(null)} style={{ background: "#f87171", color: "#fff", border: "none", borderRadius: "8px", padding: "8px" }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}